import { h, Host } from "@stencil/core";
/**
 * An action with a confirmation modal.
 */
export class EsActionWithConfirmation {
    constructor() {
        this.requestDeletion = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.open = true;
        };
        this.closeModal = () => {
            this.open = false;
        };
        this.takingAction = false;
        this.takeActionAndClose = async () => {
            if (this.takingAction || !this.open)
                return;
            this.takingAction = true;
            await this.action();
            this.open = false;
            this.takingAction = false;
        };
        this.dropdownItem = false;
        this.action = undefined;
        this.disabled = false;
        this.icon = undefined;
        this.dot = undefined;
        this.typeToConfirm = undefined;
        this.modal = undefined;
        this.open = false;
    }
    render() {
        return (h(Host, { key: 'a84d898771699ea3d8eedf73f313e886424bc643' }, h("es-button", { key: '2b216f4c9a3bf1dd37f9acb1644b9a3b2e85ddc2', onClick: this.requestDeletion, variant: 'minimal', title: this.host.textContent ?? undefined, disabled: this.disabled }, h("es-badge", { key: '58768fcd89bea8397d41cf92768f69d2eb7c1265', slot: this.dropdownItem ? 'before' : undefined, variant: 'dot', color: this.dot, count: this.dot ? 1 : 0 }, h("es-icon", { key: 'ff3ee9b208915f2dd13d62b9a8f5e4ad3351d015', icon: this.icon, size: 20 })), this.dropdownItem && h("slot", { key: 'ca6103d8f13393b1cebb1102d50ded095a9fa64d' })), !this.disabled && (h("es-portal", { key: 'faaa2274a7c9fef1b9262470f93c33f431a2a806', backdrop: true, open: this.open, onRequestClose: this.closeModal, renderElement: () => (h("es-confirm-modal", { onRequestDeletion: this.takeActionAndClose, typeToConfirm: this.typeToConfirm, ...this.modal })) }))));
    }
    static get is() { return "es-action-with-confirmation"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["../action.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["../action.css"]
        };
    }
    static get properties() {
        return {
            "dropdownItem": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If the action is within an `es-action-dropdown`."
                },
                "attribute": "dropdown-item",
                "reflect": true,
                "defaultValue": "false"
            },
            "action": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "() => any",
                    "resolved": "() => any",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The action to take when the button is clicked."
                }
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "if the action should be disabled."
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IconDescription",
                    "resolved": "[namespace: string | symbol, name: string] | string",
                    "references": {
                        "IconDescription": {
                            "location": "import",
                            "path": "../../es-icon/types",
                            "id": "src/components/es-icon/types.ts::IconDescription"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The icon to show for the action."
                },
                "attribute": "icon",
                "reflect": false
            },
            "dot": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "HTMLEsBadgeElement['color']",
                    "resolved": "\"error\" | \"okay\" | \"warning\" | undefined",
                    "references": {
                        "HTMLEsBadgeElement": {
                            "location": "global",
                            "id": "global::HTMLEsBadgeElement"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "If a dot should be shown on the action, to indicate attention being required."
                },
                "attribute": "dot",
                "reflect": false
            },
            "typeToConfirm": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "If the user needs to type the passed string to enable confirmation."
                },
                "attribute": "type-to-confirm",
                "reflect": false
            },
            "modal": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "ConfirmModalOptions",
                    "resolved": "ConfirmModalOptions",
                    "references": {
                        "ConfirmModalOptions": {
                            "location": "import",
                            "path": "../../modals/es-confirm-modal/types",
                            "id": "src/components/modals/es-confirm-modal/types.ts::ConfirmModalOptions"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The text to display within the modal."
                }
            }
        };
    }
    static get states() {
        return {
            "open": {}
        };
    }
    static get elementRef() { return "host"; }
}
//# sourceMappingURL=es-action-with-confirmation.js.map
